var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import waitForTarget from 'wait-for-target';
import { createDebug } from '@rambler-id/debug';
var debug = createDebug('common:metrics:ya');
var DEFAULT_YANDEX_METRICA_PARAMS = {
    clickmap: true,
    trackLinks: true,
    triggerEvent: true,
    accurateTrackBounce: true,
    trackHash: true,
    webvisor: true
};
export var activateYandexMetrika = function (option) {
    return new Promise(function (resolve) {
        if (process.env.NODE_ENV === 'development') {
            resolve();
            return;
        }
        /* eslint-disable */
        // prettier-ignore
        (function (m, e, t, r, i, k, a) {
            // @ts-ignore
            m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments); };
            // @ts-ignore
            m[i].l = 1 * new Date();
            k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, k.onload = function () { return resolve(); }, k.onerror = function () { return resolve(); }, a.parentNode.insertBefore(k, a);
        })(window, document, 'script', '//mc.yandex.ru/metrika/tag.js', 'ym');
        try {
            var options = Array.isArray(option) ? option : [option];
            options.forEach(function (_a) {
                var key = _a.key, params = _a.params;
                // @ts-ignore
                ym(key, 'init', __assign(__assign({}, DEFAULT_YANDEX_METRICA_PARAMS), params));
            });
        }
        catch (e) { }
        /* eslint-enable */
    });
};
export var createYandexMetrikaSetParams = function (key) {
    return function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var yaCounter, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (process.env.NODE_ENV === 'development') {
                        debug("yandexMetrikaSetParams ".concat(key, " %o"), params);
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, waitForTarget(
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        function () { return window.ym; }, 1000)];
                case 2:
                    yaCounter = _b.sent();
                    yaCounter(key, 'params', params);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var createYandexMetrikaReachGoal = function (key) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var yaCounter, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (process.env.NODE_ENV === 'development') {
                            debug("yandexMetrikaReachGoal ".concat(key, " %o"), args);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, waitForTarget(
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            function () { return window.ym; }, 1000)];
                    case 2:
                        yaCounter = _b.sent();
                        yaCounter.apply(void 0, __spreadArray([key, 'reachGoal'], args, false));
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
};
